export type ListingType = 'service' | 'good' | 'product' | 'event' | 'news'

export interface User {
  id: string
  name: string
  email: string
  avatar: string
  walletBalance: number
  location: string
  joinedDate: string
}

export interface Listing {
  id: string
  type: ListingType
  title: string
  description: string
  image: string
  price?: number
  location: string
  views: number
  createdAt: string
  userId: string
  userName: string
  userAvatar: string
  eventDate?: string
  eventTime?: string
}

export interface Review {
  id: string
  userName: string
  userAvatar: string
  rating: number
  comment: string
}

export interface Partner {
  id: string
  name: string
  logo: string
}

export interface AnonymousThought {
  id: string
  content: string
}

export const LISTING_PRICES: Record<ListingType, number> = {
  news: 0,
  service: 50,
  good: 50,
  product: 50,
  event: 50,
}

export const LISTING_TYPE_LABELS: Record<ListingType, string> = {
  service: 'Service',
  good: 'Good',
  product: 'Product',
  event: 'Event',
  news: 'News',
}
